import { useEffect, useState } from 'react';
import { IApiCallState } from '../model/IApiCallState';
import errorHandler from '../service/errorHandler';
import { dealersApi } from '../api/dealersApi';

export default function useSearchDealer(
  isCallNeeded: boolean,
  search: string,
  dependencies: any[],
): IApiCallState<any> {
  let isLoading = false;
  const error: any = null;
  let response: any = null;

  const [state, setState] = useState<IApiCallState<any>>({
    isLoading,
    error,
    response,
  });
  useEffect(
    () => {
      if (isCallNeeded) {
        isLoading = true;
        setState({
          response,
          error,
          isLoading,
        });
        dealersApi
          .searchDealers(search)
          .then(data => {
            response = {
              ...data.data.items,
            };
            isLoading = false;
            setState({
              isLoading,
              response,
              error,
            });
          })
          .catch(error => {
            errorHandler.handleError(error);
            isLoading = false;
            setState({
              response,
              error,
              isLoading,
            });
          });
      }
    },
    dependencies ? dependencies : [],
  );

  return { ...state };
}
